import React from "react";

import { CheckOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from "lottie-react";

import SuccessAnimationData from "../../../../assets/images/common/animation/SuccessAnimation.json";

import "./UsageMetricsCreditSuccessModal.css";

export default function UsageMetricsCreditSuccessModal({
  open,
  onClose,
  credits = 0,
}) {
  const formattedCredits = Number(credits).toLocaleString("en-US");

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      destroyOnHidden
      width={560}
      className="UsageMetricsCreditSuccessModal"
    >
      <div className="UsageMetricsCreditSuccessModal__Content">
        <div className="UsageMetricsCreditSuccessModal__Animation" aria-hidden>
          <Lottie animationData={SuccessAnimationData} loop={false} />
        </div>

        <p className="UsageMetricsCreditSuccessModal__Message">
          Your account is credited with
          {" "}
          <span className="UsageMetricsCreditSuccessModal__Credits">
            {`${formattedCredits} test credits`}
          </span>
        </p>

        <Button
          type="primary"
          icon={<CheckOutlined />}
          className="UsageMetricsCreditSuccessModal__GotItButton"
          onClick={onClose}
        >
          Got It
        </Button>
      </div>
    </Modal>
  );
}
